import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
  ViewChild
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaquinaMovil } from '../../../entity-maquinas-moviles/entity-maquinas-moviles.model';
import { NotificationService } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { Store } from '@ngrx/store';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import {
  entityMaquinaMovilAddRequest,
  entityMaquinaMovilUpdateRequest
} from '../../../entity-maquinas-moviles/entity-maquinas-moviles.actions';
import { FormActionType } from '@rpe/registro-personas-empresas-lib';
import { RegistroActividadMaquinasMovilesFormComponent } from '../registro-actividad-maquinas-moviles-form/registro-actividad-maquinas-moviles-form.component';

@Component({
  selector: 'rpe-registro-actividad-maquinas-moviles-form-container',
  templateUrl:
    './registro-actividad-maquinas-moviles-form-container.component.html',
  styleUrls: [
    './registro-actividad-maquinas-moviles-form-container.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistroActividadMaquinasMovilesFormContainerComponent
  implements OnInit
{
  @ViewChild('actividadMaquinaMovilForm')
  private actividadMaquinaMovilForm: RegistroActividadMaquinasMovilesFormComponent;

  maquinaMovil: MaquinaMovil = null;

  maquinaMovilValid = false;

  constructor(
    private alertService: NotificationService,
    private dialogRef: MatDialogRef<RegistroActividadMaquinasMovilesFormContainerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      maquinaMovil: MaquinaMovil;
      type: FormActionType;
    },
    private store: Store<State>
  ) {
    this.maquinaMovil = data.maquinaMovil || null;
  }

  ngOnInit(): void {}

  onAdd(): void {
    if (this.maquinaMovilValid) {
      if (this.data.type === FormActionType.Add) {
        this.store.dispatch(
          entityMaquinaMovilAddRequest({ item: this.maquinaMovil })
        );
      }

      if (this.data.type === FormActionType.Update) {
        this.store.dispatch(
          entityMaquinaMovilUpdateRequest({ item: this.maquinaMovil })
        );
      }

      this.dialogRef.close(this.maquinaMovil);
    } else {
      this.actividadMaquinaMovilForm.markAsTouched();
      this.alertService.error('Formulario inválido');
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onMaquinaMovilChange(maquinaMovil: MaquinaMovil): void {
    this.maquinaMovil = maquinaMovil;
  }

  onMaquinaValidStatusChange(valid: boolean): void {
    this.maquinaMovilValid = valid;
  }
}
